import { useState } from "react";
import { Menu, MenuItem, Tooltip, Box } from "@mui/material";
import Badge from "../../reusableComponents/Badge/Badge";
import PropTypes from "prop-types";

const STATUS_COLORS = {
    ToDo: "warning",
    Running: "info",
    Postponed: "secondary",
    Cancelled: "error",
    Completed: "success",
};

const StatusBadge = ({ status, onChangeStatus, t , canChange = false}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleStatusSelect = (newStatus) => {
        onChangeStatus(newStatus);
        handleClose();
    };

    return (
        <>
            <Tooltip title={t(status)}>
                <Box component="span">
                    <Badge
                        badgeContent={t(status)}
                        color={STATUS_COLORS[status] || "default"}
                        variant="gradient"
                        onClick={canChange ? handleClick : undefined}
                    />
                </Box>
            </Tooltip>

            <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {Object.keys(STATUS_COLORS).map((option) => (
                    <MenuItem
                        key={option}
                        onClick={() => handleStatusSelect(option)}
                        selected={option === status}
                    >
                        {t(option)}
                    </MenuItem>
                ))}
            </Menu>
        </>
    );
};

StatusBadge.propTypes = {
    canChange: PropTypes.bool,
    onChangeStatus: PropTypes.func,
    t: PropTypes.func,
    status: PropTypes.string
}
export default StatusBadge;
